import {useEffect, useState} from 'react'

export const useWelcomeMessage = () => {
    const [firstTime, setFirstTime] = useState(false)
    const [welcomeMessage, setWelcomeMessage] = useState('')
    const [username, setUsername] = useState('')

    useEffect(()=>{
        const firstTime = JSON.parse(window.localStorage.getItem('first_time'))
        setFirstTime(firstTime)
        const welcomeMessage = window.localStorage.getItem('ceo_welcome_message')
        setWelcomeMessage(welcomeMessage)
        const userName = window.localStorage.getItem('username')
        setUsername(userName)
        window.localStorage.removeItem('first_time')
    }, [])

    return {firstTime, welcomeMessage, username}
}